<mat-chip
  style="margin: 1px; white-space: nowrap"
  *ngIf="tag && !(tag.hidden && !admin) && (hide$ | async) === false"
  [matTooltip]="admin ? tag.id : 'Video Tag'"
  ><mat-icon [ngClass]="(tag.locked && admin) || icon ? 'icon' : 'noIcon'">{{
    tag.locked && admin ? 'lock' : icon ? icon : ''
  }}</mat-icon
  >{{ tag.label }}</mat-chip
>
